import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { SvgIconComponent } from 'angular-svg-icon';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { WeeklyHoursService, WeeklyHoursReportSummary } from '../../../services/weekly-hours.service';
import { FlagService } from '../../../shared/services/flag.service';
import { FlagType } from '../../../shared/utils/enums';

@Component({
  selector: 'app-weekly-hours-list',
  standalone: true,
  imports: [CommonModule, SvgIconComponent, TooltipModule],
  templateUrl: './weekly-hours-list.component.html',
  styleUrl: './weekly-hours-list.component.scss'
})
export class WeeklyHoursListComponent implements OnInit {
  reports: WeeklyHoursReportSummary[] = [];
  loading = false;
  sendingId: number | null = null;

  constructor(
    private service: WeeklyHoursService,
    private router: Router,
    private flag: FlagService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.service.list().subscribe({
      next: (data) => {
        this.reports = data ?? [];
        this.loading = false;
      },
      error: () => {
        this.flag.displayFlag('Erreur lors du chargement des relevés', FlagType.error);
        this.loading = false;
      }
    });
  }

  open(report: WeeklyHoursReportSummary): void {
    this.router.navigate(['/agency/weekly-hours', report.id]);
  }

  send(report: WeeklyHoursReportSummary, event: MouseEvent): void {
    event.stopPropagation();
    if (!report.canSendNow) return;
    this.sendingId = report.id;
    this.service.send(report.id).subscribe({
      next: () => {
        this.flag.displayFlag('Relevé envoyé à l\'établissement', FlagType.success);
        this.sendingId = null;
        this.load();
      },
      error: () => {
        this.flag.displayFlag('Erreur lors de l\'envoi', FlagType.error);
        this.sendingId = null;
      }
    });
  }

  statusLabel(s: string): string {
    return s === 'SENT' ? 'Envoyé' : s === 'READY' ? 'Prêt' : 'Brouillon';
  }
}
